import { axiosFactory, errorHandler, currentPage } from "@/configs/axios";

const devicesList = {
  api: () => {
    return axiosFactory()
      .auth.get(`devices/${currentPage()}`)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        errorHandler(error);
      });
  },
};

export { devicesList };
